/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';
import {TagType} from "../../../data/aem.model";
import {RemovableItem} from "../../atoms/RemovableItem";
import Block from "../../atoms/layout/Block";
import {createSelector} from 'reselect';
import {withI18N} from "../../hoc/withI18N";


class SelectedTags extends React.Component {

    static propTypes = {
        tags: PropTypes.arrayOf(PropTypes.shape(TagType)),
        selected: PropTypes.arrayOf(PropTypes.shape(TagType)),
        onTagSelect: PropTypes.func.isRequired,
        showSearchItemAsFilter: PropTypes.bool,
        searchTerm: PropTypes.string,
        setSearch: PropTypes.func
    };

    constructor(props) {
        super(props);

        this.orderedTagsSelector = createSelector(
            (props) => props.selected,
            (selectedTags) => {
                return [].concat(selectedTags)
                    .sort((a, b) => a.path.length - b.path.length)
                    .reduce((selected, tag, i, arr) => {
                        const parent = selected.findIndex(node => tag.id.startsWith(node.tag.id + "/"));

                        if (parent === -1) {
                            selected.push({ tag, children: [] });
                        } else {
                            const parentNode = selected[parent];

                            if (parentNode) {
                                const subpath = tag.id.substr(parentNode.tag.id.length + 1);
                                let separatorIndex = subpath.indexOf("/");

                                if (separatorIndex === -1) {
                                    parentNode.children.push(tag);
                                } else {
                                    // in case of a/b/c, access "b"
                                    const intermediateNode = parentNode.tag.children.find((tag) => tag.id === parentNode.tag.id + "/" + subpath.substr(0, separatorIndex));

                                    if (!intermediateNode) {
                                        parentNode.children.push(tag);
                                    } else {
                                        // if all children of "b" are checked, shows "b" instead of all children "c"
                                        const uncheckedChildren = intermediateNode.children.filter(child => {
                                            return arr.findIndex(a => a.id === child.id) === -1
                                        });

                                        if (uncheckedChildren.length > 0) {
                                            parentNode.children.push(tag);
                                        } else if (parentNode.children.indexOf(intermediateNode) === -1) {
                                            parentNode.children.push(intermediateNode);
                                        }
                                    }
                                }
                            } else {
                                parentNode.children.push(tag);
                            }
                        }
                        return selected;
                    }, [])
            }
        )
    }

    render() {
        if (!this.props.selected || this.props.selected.size === 0) {
            return null;
        }

        return (<Block className="selected__tags">
            <ul>
                <li className={"text-small-semi-bold selected__tags-title"}>{this.props.translate("Filters") + ":"}</li>
                {this.orderedTagsSelector(this.props)
                    .map(({tag, children}) => <li key={tag.id} className={children.length > 0 ? "withChild" : null}>
                        <RemovableItem className="tag-label" label={tag.title} remove={() => this.props.onTagSelect(tag.id)}/>
                        {children.length > 0 && <ul>
                            {children.map(child => <li key={child.id}>
                                <RemovableItem key={child.id} className="tag-label" label={child.title}
                                               remove={() => this.props.onTagSelect(child.id)}/>
                            </li>)}
                        </ul>}
                    </li>)}
                {this.props.showSearchItemAsFilter && this.props.searchTerm &&
                    <li key={"searchTerm"}>
                        <RemovableItem key={"searchTerm"} className="tag-label" label={this.props.searchTerm}
                                       remove={() => this.props.setSearch("")}/>
                    </li>
                }
            </ul>
        </Block>)
    }

}

export default withI18N(SelectedTags);
